<div class="container">
    <h1 class="text-uppercase">Releases</h1>

    <app-release-assignment [product]="product" [channels]="channels" [releases]="releases" (cancel)="returnToProduct()"
        (publishRelease)="publish($event)" (download)="downloadClicked($event)" [publishing]="publishing"
        [downloading]="downloading" [downloadPermission]="downloadPermission"
        [changeReleasePermission]="changeReleasePermission"></app-release-assignment>
</div>